import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { usePrevious } from "src/hooks/usePrevious";
import { isUrlWithSerializedId, getPageRedirectUrlAlias } from "src/utils";

export const usePageUrlRedirectAliases = (): void => {
  const navigateTo = useNavigate();
  const { pathname, search } = useLocation();
  const url = `${pathname}${search}`;

  const previousPathname = usePrevious(pathname);
  const previousSearch = usePrevious(search);
  const prevUrl = `${previousPathname}${previousSearch}`;

  useEffect(() => {
    const isRouteChanged = url !== prevUrl;

    if (isRouteChanged && isUrlWithSerializedId(url)) {
      navigateTo(getPageRedirectUrlAlias(pathname, search), { replace: true });
    }
  }, [url, prevUrl, pathname, search, navigateTo]);
};
